import { FC } from 'react'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import "./style.css"
import { IDropDown } from './DropDown.type'

const DropDown: FC<IDropDown> = ({ val, setVal, options, label, isMulti, disabled, placeholder = "All", className, isClearable = true }) => {
    const { t } = useTranslation()

    return (
        <div className={`form-group ${className}`}>
            <label>{t(label)}</label>
            <Select
                isMulti={isMulti}
                isDisabled={disabled}
                className="MultiSelect"
                classNamePrefix="MultiSelect"
                placeholder={`${t("Select")} ${t(`${placeholder}`)}`}
                options={options?.map((option: any) => ({ ...option, label: t(option.label), value: option.value }))}
                value={val}
                id={label}
                onChange={setVal}
                isClearable={isClearable}
                isSearchable
                menuPortalTarget={document.body}
                closeMenuOnScroll={(e: Event): boolean => {
                    const target = e.target as HTMLElement;
                    return !target?.closest?.('.MultiSelect__menu-list');
                }}
            />
        </div>
    )
}

export default DropDown